<template>
  <el-form
    class="post-container"
    ref="form"
    :model="form"
    :rules="rules"
    v-loading="isLoading"
  >
    <h1 class="page-title">发布贴文</h1>
    <div class="post-main">
      <span class="min-title">发送到</span>
      <div class="post-send-to">
        <span class="m-t-10">已选专页:</span>
        <el-form-item class="tag-group">
          <el-tag
            v-for="item in form.tagsSelect"
            :key="item.id"
            closable
            @close="tagClose(item)"
            @click="tagClick(item)"
            v-model="form.tagsSelect"
          >
            {{ item.pageName }}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
            placeholder="输入专页名称或ID"
          >
          </el-input>
          <el-button
            v-else
            class="button-new-tag"
            size="medium"
            @click="showInput"
            >+ 添加</el-button
          >
        </el-form-item>
        <el-collapse>
          <el-collapse-item title="请选择专页:" name="1">
            <el-form-item class="tag-select">
              <el-row v-for="(value, key) in data" :key="key">
                <el-col>
                  <el-checkbox
                    v-model="form[`tag_${key}`]"
                    @change="changeSelect"
                    :name="key"
                  ></el-checkbox>
                  <span class="tag-title"> {{ key }}</span>
                </el-col>
                <el-col>
                  <el-tag
                    v-for="item in value"
                    :key="item.id"
                    @click="tagSelect(item)"
                    type="info"
                    effect="plain"
                  >
                    {{ item.pageName }}
                    <i class="el-icon-success" v-show="ifSelect(item)"></i>
                  </el-tag>
                </el-col>
              </el-row>
            </el-form-item>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="m-t-10">
        <span class="min-title">文本消息</span>
        <el-form-item class="post-box" prop="text">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入内容"
            v-model="form.text"
          >
          </el-input>
        </el-form-item>
      </div>
      <div class="m-t-10">
        <span class="min-title">留言信息</span>
        <el-form-item class="post-box" prop="message">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入留言"
            v-model="form.message"
          >
          </el-input>
        </el-form-item>
      </div>
      <div class="post-insert">
        <span class="min-title m-r-10">插入</span>
        <div>
          <el-button-group prop="text">
            <el-button
              :type="appendix === 1 ? 'primary' : 'form'"
              size="medium"
              @click="appendix = 1"
              >插入链接</el-button
            >
            <el-button
              :type="appendix === 2 ? 'primary' : 'form'"
              size="medium"
              @click="appendix = 2"
              >插入图片</el-button
            >
            <el-button
              :type="appendix === 3 ? 'primary' : 'form'"
              size="medium"
              @click="appendix = 3"
              >随机背景</el-button
            >
          </el-button-group>
          <el-form-item
            class="post-insert-item"
            v-show="appendix === 1"
            prop="link"
          >
            <el-input v-model="form.link" placeholder="请输入链接"></el-input>
          </el-form-item>
          <el-form-item
            class="post-insert-item"
            v-show="appendix === 2"
            prop="file"
          >
            <el-upload
              action="#"
              ref="upload"
              list-type="picture-card"
              accept=".jpeg, .jpg, .png"
              :auto-upload="false"
              :file-list="fileList"
              :on-change="fileChange"
              :on-remove="fileRemove"
              :on-preview="pictureCardPreview"
              :on-exceed="exceed"
              :limit="1"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </el-form-item>
        </div>
      </div>
      <div class="post-time">
        <span class="min-title m-r-10">发布时间</span>
        <el-button-group prop="text">
          <el-button
            :type="immediately ? 'primary' : 'form'"
            size="medium"
            @click="immediately = true"
            >立即发布</el-button
          >
          <el-button
            :type="immediately ? 'form' : 'primary'"
            size="medium"
            @click="immediately = false"
            >定时发布</el-button
          >
        </el-button-group>
        <div class="dis-flex input-date">
          <el-form-item prop="date">
            <el-date-picker
              v-show="!immediately"
              v-model="form.date"
              size="medium"
              type="datetime"
              placeholder="选择日期时间"
              value-format="timestamp"
              format="yyyy/MM/dd HH:mm:ss"
              :default-value="new Date()"
              :picker-options="pickerOptions"
              @change="beginDateChange"
            ></el-date-picker>
          </el-form-item>
          <div class="m-l-10" prop="interval" v-show="!immediately">
            <span class="m-r-10">发布间隔(分钟)</span>
            <el-input-number
              v-model="form.interval"
              size="medium"
              :min="0"
            ></el-input-number>
          </div>
        </div>
      </div>
      <div class="submit-box">
        <el-button
          type=""
          :disabled="publish.loading === true"
          @click="reset('form')"
          class="submit"
          >重置内容</el-button
        >
        <el-button
          type="primary"
          v-loading.fullscreen.lock="publish.loading"
          :element-loading-text="publish.text_pending"
          @click="submit('form')"
          class="submit"
          >{{ publish.text_wait }}</el-button
        >
      </div>
    </div>
  </el-form>
</template>

<script>
import getBindPageNameByUserId from "@/api/getBindPageNameByUserId.js";
import addSend from "@/api/addSend.js";
import addSendQueue from "@/api/addSendQueue.js";
import requstData from "@/mixins/requstData.js";
import { mapState } from "vuex";
import { link, fbLink } from "@/utils/regexp.js";
export default {
  watch: {
    data: function (n, o) {
      if (n.length === 0) {
        this.tipBind();
      }
    },
  },
  computed: {
    ...mapState("loginUser", ["user"]),
  },
  mixins: [requstData([])],
  data() {
    var ruleLink = (rule, value, callback) => {
      if (this.appendix === 1) {
        if (this.form.text === "" && !link.test(this.form.link)) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "请输入链接",
              type: "error",
            });
          }, 100);
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var ruleImg = (rule, value, callback) => {
      if (this.appendix === 2) {
        if (this.form.text === "" && this.fileList.length === 0) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "请添加图片",
              type: "error",
            });
          }, 100);
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var ruleDate = (rule, value, callback) => {
      if (!this.immediately && this.form.date === "") {
        setTimeout(() => {
          this.$message({
            showClose: true,
            message: "请选择日期",
            type: "error",
          });
        }, 200);
      } else {
        callback();
      }
    };
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      appendix: 1, //1链接 2图片 3随机背景
      immediately: true,
      fileList: [],
      inputVisible: false,
      inputValue: "",
      publish: {
        loading: false,
        text_pending: "发布中",
        text_wait: "发布",
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      form: {
        tagsSelect: [],
        text: "",
        message: "",
        link: "",
        date: "",
        interval: 0,
      },
      rules: {
        link: [{ validator: ruleLink, trigger: "clear" }],
        file: [{ validator: ruleImg, trigger: "change" }],
        date: [{ validator: ruleDate, trigger: "change" }],
      },
    };
  },
  methods: {
    async requst(params) {
      return await getBindPageNameByUserId();
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue.trim();
      if (inputValue) {
        let data = Object.values(this.data).flat();
        let item = data.find((value) => {
          return (
            inputValue === (isNaN(inputValue) ? value.pageName : value.pageId)
          );
        });
        if (item) {
          this.tagSelect(item);
        } else {
          this.$message({
            showClose: true,
            message: "该专页未找到",
            type: "error",
          });
        }
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    changeSelect(type, event) {
      let key = event.target.name;
      let data = this.data[key];
      data.forEach((item) => {
        if (type) {
          this.tagSelect(item);
        } else {
          this.tagClose(item);
        }
      });
    },
    ifSelect(data) {
      return this.form.tagsSelect.find((value) => value.id === data.id);
    },
    tagSelect(data) {
      if (!this.ifSelect(data)) {
        this.form.tagsSelect.push(data);
        let key = `tag_${data.flagGroup}_num`;
        this.form[key] = this.form[key] ? this.form[key] + 1 : 1;
        if (this.form[key] === this.data[data.flagGroup].length) {
          this.form[`tag_${data.flagGroup}`] = true;
        }
      }
    },
    tagClose(data) {
      this.form.tagsSelect = this.form.tagsSelect.filter(
        (value) => value.id !== data.id
      );
      this.form[`tag_${data.flagGroup}_num`] -= 1;
      this.form[`tag_${data.flagGroup}`] = false;
    },
    tagClick(data) {
      window.open(`https://www.facebook.com/${data.pageId}`);
    },
    pictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    beginDateChange(date) {
      if (!date) {
        return;
      }
      let t = 10 * 60 * 1000; //默认限制15分钟后发布
      if (date - new Date().getTime() < t) {
        this.form.date = new Date().getTime() + t;
      }
    },
    fileChange(data) {
      this.fileList.push(data);
    },
    fileRemove(data) {
      this.fileList = this.fileList.filter((item) => data.name !== item.name);
    },
    exceed(files, fileList) {
      this.clearFiles();
      this.$set(fileList[0], "raw", files[0]);
      this.$set(fileList[0], "name", files[0].name);
      this.$refs.upload.handleStart(files[0]); //选择文件后的赋值方法
    },
    submit(form) {
      if (this.data.length === 0) {
        this.tipBind();
        return;
      }
      if (this.form.tagsSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择专页",
          type: "error",
        });
        return;
      }
      if (this.form.text !== "" && fbLink.test(this.form.text)) {
        this.$message({
          showClose: true,
          message: "请勿在正文中添加Facebook相关域名链接",
          type: "error",
        });
        return;
      }
      this.$refs[form].validate(async (valid) => {
        if (valid) {
          const { tagsSelect, text, link, date, interval, message } = this.form;
          const formData = new FormData();
          formData.append(
            "imageFile",
            this.appendix === 2 ? this.fileList[0].raw : new File([], "")
          );
          formData.append("content", text);
          formData.append("leaveMessage", message);
          formData.append(
            "pageName",
            tagsSelect
              .map((item) => {
                return item.pageName;
              })
              .join(",")
          );
          formData.append(
            "pageId",
            tagsSelect
              .map((item) => {
                return item.pageId;
              })
              .join(",")
          );
          formData.append("sendType", this.appendix === 2 ? 2 : 1);
          formData.append(
            "sendTime",
            this.immediately ? new Date().getTime() : date
          );
          formData.append("status", this.immediately ? 1 : 3);
          if (!this.immediately) {
            formData.append("timeInterval", interval);
          }
          if (this.appendix === 1) {
            formData.append("link", link);
          }
          this.publish.loading = true;
          if (this.immediately) {
            let res = await addSend(formData);
            if (res) {
              const h = this.$createElement;
              this.$notify({
                title: "已发布",
                message: h("div", null, [
                  h("p", null, `贴文发布失败数量: ${res.postingFailNum}`),
                  h("p", null, `留言发布失败数量: ${res.leaveMessageFailNum}`),
                ]),
                type: "success",
              });
              this.reset();
            }
          } else {
            let res = await addSendQueue(formData);
            if (res) {
              const h = this.$createElement;
              this.$notify({
                title: "已排期",
                message: "定时贴文已排期",
                type: "success",
              });
              this.reset();
            }
          }
          this.publish.loading = false;
        } else {
          return false;
        }
      });
    },
    reset(form) {
      this.$refs.form.resetFields();
      this.clearFiles();
      for (let key in this.data) {
        this.form[`tag_${key}_num`] = 0;
        this.form[`tag_${key}`] = false;
      }
    },
    tipBind() {
      this.$message({
        showClose: true,
        message:
          this.user.role === "1" || this.user.role === "4"
            ? "无绑定专页，请前往授权中心授权！"
            : "无绑定专页，请联系管理员授权！",
        type: "warning",
      });
    },
    clearFiles() {
      this.$refs.upload.clearFiles();
      this.fileList = [];
    },
  },
};
</script>

<style lang="less" scoped>
.post-container {
  padding: 50px 30px 30px 40px;
  background: #fff;

  .min-title {
    display: block;
    min-width: 64px;
    margin-bottom: 10px;
  }

  .post-main {
    width: 60%;
    min-width: 1000px;
    margin-top: 10px;
    padding: 10px;

    .post-send-to {
      background: #f4f5f9;
      padding: 15px 15px;
      font-size: 14px;
      color: rgba(37, 38, 50, 0.6);

      .tag-group {
        min-height: 40px;
        margin: 10px 0;
        border-bottom: 1px solid #eaeaea;
        padding-bottom: 10px;

        .el-tag {
          background: rgba(5, 109, 232, 0.1);
          color: rgb(5, 109, 232);
          margin-right: 20px;
          transform: scale(1.1);
          cursor: pointer;
          //line-height: 32px;
        }
      }

      .el-collapse {
        border-top: 0px;
        border-bottom: 0px;
      }

      .el-collapse-item {
        ::v-deep .el-collapse-item__header {
          color: inherit;
          background-color: inherit;
          border-bottom: 0px;
        }
      }
    }

    .tag-select {
      padding: 0 15px;
      .el-tag {
        margin-right: 15px;
        cursor: pointer;
        transform: scale(1.1);
        line-height: 32px;
        padding: 0 15px;

        .el-icon-success {
          position: absolute;
          top: -4px;
          right: -4px;
          color: #3470fb;
          font-size: 14px;
        }
      }

      .el-tag--plain.el-tag--info {
        color: #000;
      }

      .el-tag:hover {
        border-color: #3470fb;
        color: #3470fb;
        transform: scale(1.08);
        transition-duration: 0.25s, 1s;
      }

      .tag-title {
        margin-left: 5px;
        color: #3ba0fe;
      }
    }

    .post-insert {
      padding-top: 10px;
      align-items: flex-start;

      .post-insert-item {
        margin: 15px 0;
      }

      .el-input {
        width: 500px;
      }
    }

    .post-time {
      padding-top: 10px;
      align-items: flex-start;

      .input-date {
        margin-top: 10px;
        align-items: center;
        line-height: 40px;
      }
    }

    .submit-box {
      margin-top: 30px;

      .el-button {
        min-width: 130px;
      }

      .el-button:hover {
        transform: scale(1.08);
        transition-duration: 0.25s, 1s;
      }
    }

    .el-form-item {
      margin-bottom: 0;
    }
  }
}
</style>
